import * as THREE from 'three';
import gsap from 'gsap';

import vs from "./shaders/vert.glsl";
import fs from "./shaders/frag.glsl";


export default class SlideMesh{

    constructor(textures){
        this.textures = textures;

        this.$canvas = document.getElementById('js-slide-canvas');
        this.$titleList = [...document.querySelectorAll('.js-slide__title__item')];
        this.$nameList = [...document.querySelectorAll('.slide__name')];
        this.$srcList = [...document.querySelectorAll('.js-slide-targets img')];

        this.uniforms = {};
        this.geometry = null;
        this.material = null;
        this.mesh = null;
        this.nowIndex = 1;
        this.maxIndex = Object.keys(this.textures).length-1;    // noiseの画像分を除く
        this.csize = this._getGeoSize();
        this.initsize = this.csize;

        this._init();
    }


    prev(){
        let tIndex = this.nowIndex-1;
        if(tIndex < 1) tIndex = this.maxIndex;
        this.change(tIndex, 'prev');
    }


    next(){
        let tIndex = this.nowIndex+1;
        if(tIndex > this.maxIndex) tIndex = 1;
        this.change(tIndex, 'next');
    }


    change(index, vect='next'){
        const beforeIdx = this.nowIndex;
        this.nowIndex = index;
        
        this.csize = this._getGeoSize();
        this.initsize = this.csize;
        this.mesh.geometry = new THREE.PlaneGeometry(this.csize.w, this.csize.h, 1);
        this.mesh.scale.set(1, 1);

        // 画像の更新
        if(vect === 'next') this._nextAnime();
        else this._prevAnime();

        // タイトルの更新
        this.$titleList[beforeIdx-1].classList.remove('-active');
        this.$titleList[this.nowIndex-1].classList.add('-active');

        // nameの更新
        this.$nameList[beforeIdx-1].classList.remove('-active');
        this.$nameList[this.nowIndex-1].classList.add('-active');
    }


    _nextAnime(){
        this.uniforms.uNextImage.value = this.textures[`img${this.nowIndex}`];
        this.uniforms.uNextImage.needsUpdate = true;
        this.uniforms.uDispFactor.value = 0.0;

        gsap.killTweensOf(this.uniforms.uDispFactor);
        gsap.to(this.uniforms.uDispFactor, {
            duration:0.6, value:1.0, ease:'power2.out',
            onComplete: ()=>{
                this.uniforms.uCurrentImage.value = this.textures[`img${this.nowIndex}`];
                this.uniforms.uCurrentImage.needsUpdate = true;
                this.uniforms.uDispFactor.value = 0.0;
            }
        });
    }


    _prevAnime(){
        this.uniforms.uCurrentImage.value = this.textures[`img${this.nowIndex}`];
        this.uniforms.uCurrentImage.needsUpdate = true;
        this.uniforms.uDispFactor.value = 1;

        gsap.killTweensOf(this.uniforms.uDispFactor);
        gsap.to(this.uniforms.uDispFactor, {
            duration:0.6, value:0.0, ease:'power2.out',
            onComplete: ()=>{
                this.uniforms.uNextImage.value = this.textures[`img${this.nowIndex}`];
                this.uniforms.uNextImage.needsUpdate = true;
                this.uniforms.uDispFactor.value = 1.0;
            }
        });
    }


    resize(){
        this.csize = this._getGeoSize();
        const s = this.csize.w / this.initsize.w;
        this.mesh.scale.set(s, s);
    }


    _init(){
        this.uniforms = {
            uDispFactor: { type:"f", value:0.0 },
            uDisp: { type:"t", value:this.textures['noise'] },
            uCurrentImage: { type:"t", value:this.textures[`img${this.nowIndex}`] },
            uNextImage: { type:"t", value:this.textures[`img${this.nowIndex+1}`] }
        };

        this.geometry = new THREE.PlaneGeometry(this.csize.w, this.csize.h, 1);
        this.material = new THREE.ShaderMaterial({
            uniforms: this.uniforms,
            vertexShader: vs,
            fragmentShader: fs,
            transparent: true,
            opacity: 1.0
        });

        this.mesh = new THREE.Mesh(this.geometry, this.material);
    }

    _getGeoSize(){
        const $src = this.$srcList[this.nowIndex-1];
        const rec = $src.getBoundingClientRect();
        return {w:Math.round(rec.width), h:Math.round(rec.height)};
    }
}